import React from 'react'
import { DateTime } from 'luxon'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const MessageScheduleBanner = ({ count, date, onClick }) => {
  const formatedDate = DateTime.fromISO(date).setLocale('es-ES').toFormat('DDD')
  const formatedTime = DateTime.fromISO(date).setLocale('es-ES').toFormat('T')

  return (
    <div className='message-schedule-banner'>
      <figure className='message-schedule-banner__icon'>
        <img src={getStaticImage('/icons/orange-brand/icon-clock-dark.svg')} alt='Deferred' />
      </figure>
      {count <= 1 ? (
        <p className='message-schedule-banner__description'>
          {lang('dashboard_your-message-sent-conversation-date', { date: `${formatedDate} ${lang('dashboard_at-time')} ${formatedTime}` })}.
        </p>
      ) : (
        <p className='message-schedule-banner__description'>
          {lang('dashboard_count-messages-scheduled-sent-conversation', { count })}.
        </p>
      )}
      <button className='message-schedule-banner__btn' type='button' onClick={onClick}>
        {lang('dashboard_see-all-scheduled-messages')}
      </button>
    </div>
  )
}

export default MessageScheduleBanner
